import * as firebase from 'firebase';

var firebaseConfig = {
    apiKey: "AIzaSyAT68Z0IO4xcjviaJMf_h0nM8Tdo73E1jE",
    authDomain: "lovr-app.firebaseapp.com",
    databaseURL: "https://lovr-app.firebaseio.com",
    projectId: "lovr-app",
    storageBucket: "lovr-app.appspot.com",
    messagingSenderId: "691167646448",
    appId: "1:691167646448:web:9cc771a6962478c225a835",
    measurementId: "G-PEXDE6RBJG"
};
// Initialize Firebase
var app = firebase.initializeApp(firebaseConfig);

app.firestore().enablePersistence({synchronizeTabs:true})
.catch(function (err) {
    if (err.code == 'failed-precondition') {
        // Multiple tabs open, persistence can only be enabled
        // in one tab at a a time.
        // ...
    } else if (err.code == 'unimplemented') {
        // The current browser does not support all of the
        // features required to enable persistence
        // ...

    }
});



export default app;